import { PaginationParams, PaginationResponseType } from 'app/console-api';
import { AUTH_TOKEN } from 'app/constants';
import { HttpError } from 'app/components/utils/http-error';

export interface LogData {
  id: string;
  timestamp: Date;
  taskID: string;
  action: string;
  description: string;
  userID: string;
}

export interface TaskLogsListItemResponse {
  logData: LogData;
  userEmail: string;
}

export const getTaskLogs = async (
  appID: string,
  taskID: string,
  params: PaginationParams
): Promise<PaginationResponseType<TaskLogsListItemResponse>> => {
  const searchParams = new URLSearchParams();
  searchParams.append('pageSize', params.pageSize.toString());
  searchParams.append('currentPage', params.currentPage.toString());

  const response = await fetch(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/apps/${appID}/tasks/${taskID}/logs?${searchParams.toString()}`,
    {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${localStorage.getItem(AUTH_TOKEN) || ''}`
      }
    }
  );
  if (!response.ok) {
    return Promise.reject(
      new HttpError(`Failed to get task logs: ${response.statusText}`, response.status)
    );
  }
  return await response.json();
};
